import React from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray, map, uniqBy} from 'lodash';
import searchHoc from '../components-app/search-wrapper';

const servicesDataKey = 'featuredFolderList';

const promotedFolderDialog = ({
    id,
    editMode,
    selectedFolder,
    folderDialogVisible,
    searchData,
    handleCloseDialog,
    handleFolderChange,
    handleSubmit,
}) => (
    <Dialog
        header={!editMode ? 'Add Promoted Folder' : 'Update Promoted Folder'}
        modal={true}
        style={{width: '50vw'}}
        visible={folderDialogVisible}
        onHide={handleCloseDialog}
    >
        <Dropdown
            filter={true}
            filterBy="label,value"
            filterPlaceholder="Select Promoted Folder"
            id={id}
            options={
                isArray(searchData.featuredFolders)
                    ? map(searchData.featuredFolders, folder => ({
                          label: folder.name,
                          value: Number(folder.folderID),
                      }))
                    : []
            }
            showClear={false}
            style={{width: '300px'}}
            value={selectedFolder}
            onChange={handleFolderChange}
        />{' '}
        <br />
        <br />
        <Button label={!editMode ? 'Add Folder' : 'Update Folder'} onClick={handleSubmit} />
    </Dialog>
);

promotedFolderDialog.propTypes = {
    editMode: PropTypes.bool.isRequired,
    folderDialogVisible: PropTypes.bool.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    handleFolderChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    searchData: PropTypes.object.isRequired,
    selectedFolder: PropTypes.array,
};

export default searchHoc(promotedFolderDialog, servicesDataKey);
